<script setup lang="ts">
/** 공용 — 선언 + 서명. (3개 폼 동일) */
import CddDocVarField from './CddDocVarField.vue';
</script>

<template>
  <div class="cdd-decl">
    <div>I confirm that the facts and information stated in this document are true and to the best of my knowledge. <span class="cdd-cn">我确认本文件中所述的事实和信息是真实的，并且据我所知是准确的。</span></div>
    <div class="sig-line">______________________________</div>
    <div>Name <span class="cdd-cn">姓名</span>: <CddDocVarField field-key="signer_name" /></div>
    <div>Designation <span class="cdd-cn">职衔</span>: <CddDocVarField field-key="signer_designation" /></div>
    <div>Date <span class="cdd-cn">日期</span>: <CddDocVarField field-key="declaration_date" /></div>
  </div>
</template>
